/**
 * Hook to fetch Firebase Analytics data
 */

import { useQuery } from "@apollo/client";
import { useSalonStore } from "@/lib/store/salon";
import { GET_FIREBASE_ANALYTICS } from "../graphql/report-queries";
import { formatReportDate } from "../lib/report-date-range";
import { useReportsV2Store } from "../store/use-reports-v2-store";

export function useFirebaseAnalytics() {
  const { currentSalon } = useSalonStore();
  const { currentPeriod, comparisonPeriod } = useReportsV2Store();

  const { data, loading, error, refetch } = useQuery(GET_FIREBASE_ANALYTICS, {
    variables: {
      salonId: currentSalon?.id ?? "",
      startDate: currentPeriod
        ? formatReportDate(currentPeriod.startDate, currentSalon?.timezone || "UTC")
        : "",
      endDate: currentPeriod
        ? formatReportDate(currentPeriod.endDate, currentSalon?.timezone || "UTC")
        : "",
      comparisonStartDate: comparisonPeriod
        ? formatReportDate(comparisonPeriod.startDate, currentSalon?.timezone || "UTC")
        : undefined,
      comparisonEndDate: comparisonPeriod
        ? formatReportDate(comparisonPeriod.endDate, currentSalon?.timezone || "UTC")
        : undefined,
    },
    skip: !currentSalon || !currentPeriod,
    notifyOnNetworkStatusChange: true,
  });

  return {
    data: data?.firebaseAnalyticsReport ?? null,
    loading,
    error,
    refetch,
  };
}
